// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.print {
  size: A4;
  margin: 10mm;
  border: 1px solid black;
  }
  
  .title {
    text-align: center;
  }
  
  .table {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  
  .cell {
    width: 50%;
    height: 20%;
    border: 1px solid black;
    text-align: center;
  }
  .image-circle{
    border-radius: 50%;
  }`, "",{"version":3,"sources":["webpack://./src/pages/Views/EICView/Forms/PrintDeed.css"],"names":[],"mappings":"AAAA;EACE,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB","sourcesContent":[".print {\r\n  size: A4;\r\n  margin: 10mm;\r\n  border: 1px solid black;\r\n  }\r\n  \r\n  .title {\r\n    text-align: center;\r\n  }\r\n  \r\n  .table {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: space-between;\r\n  }\r\n  \r\n  .cell {\r\n    width: 50%;\r\n    height: 20%;\r\n    border: 1px solid black;\r\n    text-align: center;\r\n  }\r\n  .image-circle{\r\n    border-radius: 50%;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
